import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiSavePrioShareDraft } from '../../../api';

interface SavePrioShareDraftParams {
  projectExtensionId: string;
  prioShareId: string;
  name: string;
  expirationDate: string;
  recipients: { email: string }[];
  notificationEmails: string[];
  messageText: string;
  senderType: string;
  senderMailboxId: string;
}

export function useSavePrioShareDraft() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (params: SavePrioShareDraftParams) => {
      return apiSavePrioShareDraft(params.projectExtensionId, params.prioShareId, {
        name: params.name,
        expirationDate: params.expirationDate,
        recipients: params.recipients,
        notificationEmails: params.notificationEmails,
        messageText: params.messageText,
        senderType: params.senderType,
        senderMailboxId: params.senderMailboxId,
      });
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['prioShares', variables.projectExtensionId],
      });
    },
  });
}
